import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const cuttingPlansSelector =
  (materialHeaderId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, materialHeaderId)

    if (bomItem.type !== 'MaterialHeader') {
      throw 'bomItemId is not a MaterialHeader'
    }

    return bomItem.cuttingPlans
  }
